<!-- <div class="bar-arrow"> -->
<div class="arrow-connector" #arrow [ngClass]="{critical: blocker}" title="{{ sourceId }} -> {{ targetId }}"></div>
<!-- </div> -->
